export default {
  name: 'roles',
  translationKey: 'roles-module',
  routePrefix: 'roles',
  routeNamePrefix: 'admin.roles',
  directRoutesAvailable: false,
}
